import React, { useState } from 'react';
import { Box, Card, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, FormControl } from '@mui/material';
import { FormField } from '../utils/formFieldTypes';
import { renderError } from '../utils';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface ConsentSelectComponentProps {
    field: FormField; errorMessage?: string;
}

const ConsentSelectComponent: React.FC<ConsentSelectComponentProps> = ({
    field,
    errorMessage = '',
}) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedConsent, setSelectedConsent] = useState<any>(null);
    // const consents = Array.isArray(field.consent) ? field.consent : [field.consent];

    const handleOpenDialog = (consent: any) => {
        setSelectedConsent(consent);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedConsent(null);
    };

    return (
        <FormControl fullWidth margin='normal'>
            <Box>
                {/* Consent Items List */}
                <Box sx={{ marginBottom: '16px' }}>
                    {/* {consents.map((consent, index) => ( */}
                    <Card
                        // key={index}
                        // onClick={() => handleOpenDialog(consent)}
                        onClick={() => handleOpenDialog(field)}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            border: '1px solid #a3a3a3',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        {/* Left Side - Title and Description */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    color: '#fff',
                                }}
                            >
                                {/* {consent.title} */}
                                {field.title}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    color: '#fff',
                                    lineHeight: 1.5,
                                }}
                            >
                                {/* {consent.subtitle || consent.content?.substring(0, 100) + (consent.content?.length > 100 ? '...' : '')} */}
                                {field.subtitle ? field.subtitle : 'Click to view details'}
                            </Typography>
                        </Box>

                        {/* Right Side - Arrow Icon */}
                        <ArrowForwardIosIcon
                            sx={{
                                marginLeft: '16px',
                                fontWeight: 300,
                            }}
                        />
                    </Card>
                    {/* ))} */}
                </Box>

                {/* Error Message */}
                {renderError(errorMessage)}

                {/* Full Document Dialog */}
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    maxWidth='sm'
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: '8px',
                        },
                    }}
                >
                    <DialogTitle color="white">

                        {selectedConsent?.title}
                    </DialogTitle>

                    <DialogContent dividers>

                        {/* Subtitle */}
                        {selectedConsent?.subtitle && (
                            <Typography
                                variant='body2'
                                sx={{
                                    color: '#faf7f7',
                                    marginBottom: '16px',
                                    fontWeight: 500,
                                    fontStyle: 'italic',
                                }}
                            >
                                {selectedConsent.subtitle}
                            </Typography>
                        )}

                        {/* Full Content - preserve line breaks */}
                        <Typography
                            variant='body2'
                            sx={{
                                color: '#f2ebeb',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                                lineHeight: 1.8,
                            }}
                        >
                            {selectedConsent?.content}
                        </Typography>
                    </DialogContent>

                    <DialogActions sx={{ padding: '20px 30px' }}>
                        <Button
                            onClick={handleCloseDialog}
                            variant="contained"
                            type="button"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </FormControl>
    );
};

export default ConsentSelectComponent;

